import axios from "axios";
import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    clearPreviewlist,
    downloadImage,
    } from "../../../store/actions/proposalActions";

    const DocumentDetails = ({ documentDetails, proposalNumber }) => {
    const [showDocPopUp, setshowDocPopUp] = useState(false);
    const [currentImgIndex, setcurrentImgIndex] = useState(0);
    const [imgLoading, setimgLoading] = useState(true);
    const dispatch = useDispatch();

    const { previewList } = useSelector((state) => ({
        previewList: state.proposal.previewList,
    }));

    const viewDocs = useCallback(
        (docs) => {
        let CancelToken = axios.CancelToken;
        let source = CancelToken.source();
        let list = [];
        docs.map((item) => {
            list.push(item.url);
        });
        list.map((item) =>
            dispatch(downloadImage(item, proposalNumber, source.token))
        );
        setshowDocPopUp(true);
        },
        [proposalNumber]
    );

    const onPrev = useCallback(() => {
        const lastIndex = previewList.length - 1;
        const shouldResetIndex = currentImgIndex === 0;
        const index = shouldResetIndex ? lastIndex : currentImgIndex - 1;

        setcurrentImgIndex(index);
        setimgLoading(true);
    }, [currentImgIndex, previewList]);

    const onNext = useCallback(() => {
        const lastIndex = previewList.length - 1;
        const shouldResetIndex = currentImgIndex === lastIndex;
        const index = shouldResetIndex ? 0 : currentImgIndex + 1;

        setcurrentImgIndex(index);
        setimgLoading(true);
    }, [previewList, currentImgIndex]);

    return (
        <>
        <div className="document-details-container">
            {documentDetails && Object.keys(documentDetails).map((item, index) => {
            return (
                <div key={index}>
                <div className="owner-heading">
                    {Object.keys(documentDetails).find((key) => item === key)}
                </div>
                <div className="body">
                    {Object.keys(documentDetails[item]).map((docs, ind) => {
                    return (
                        <div className="docs">
                        <div key={ind} className="docs-name">
                            {docs}
                        </div>
                        <div className="doc-category">
                            {documentDetails[item][docs].map((category, i) => {
                            return (
                                <div
                                className="catg"
                                onClick={() => viewDocs(category.docs)}
                                >
                                {category.type}
                                </div>
                            );
                            })}
                        </div>
                        </div>
                    );
                    })}
                </div>
                </div>
            );
            })}
        </div>

        {showDocPopUp && (
            <div className="view-doc-container-overlay">
            <div className="view-doc-container">
                <div className="close-container">
                <div
                    className="close"
                    onClick={() => {
                    setshowDocPopUp(false);
                    dispatch(clearPreviewlist(previewList));
                    }}
                ></div>
                </div>
                <div className="img-wrapper">
                {imgLoading &&
                    !previewList[currentImgIndex]?.name.includes(".pdf") && (
                    <div className="img-loader-wrap">Loading...</div>
                    )}
                {previewList[currentImgIndex]?.name.includes(".pdf") ? (
                    <div className="pdf-thumb-wrapper">
                    <div className="pdf-placeholder"></div>
                    {!previewList[currentImgIndex].src ? (
                        <div className="">Loading...</div>
                    ) : (
                        <button
                        className="open-pdf-btn"
                        onClick={() => {
                            //const downloadFile = (blob, fileName) => {
                            const blob = new Blob(
                            [previewList[currentImgIndex]?.src],
                            {
                                type: "application/pdf",
                            }
                            );
                            const fileName = "myDocument.pdf";
                            const link = document.createElement("a");
                            // create a blobURI pointing to our Blob
                            link.href = previewList[currentImgIndex]?.src; //URL.createObjectURL(previewList[currentImgIndex]?.src);
                            link.download = fileName;
                            // some browser needs the anchor to be in the doc
                            document.body.append(link);
                            link.click();
                            link.remove();
                            // in case the Blob uses a lot of memory
                            setTimeout(() => URL.revokeObjectURL(link.href), 7000);
                            // };
                            // window.open(
                            //   window.URL.createObjectURL(new Blob(previewList[currentImgIndex]?.src, {type: "pdf"})),
                            //  // window.URL.createObjectURL(previewList[currentImgIndex]?.src),
                            //   "_blank"
                            // )
                        }}
                        >
                        Open pdf
                        </button>
                    )}
                    </div>
                ) : (
                    <img
                    className="view-img"
                    src={previewList[currentImgIndex]?.src}
                    alt="imgList"
                    style={
                        imgLoading ? { display: "none" } : { display: "block" }
                    }
                    onLoad={() => {
                        setimgLoading(false);
                    }}
                    />
                )}
                <div className="img-name">
                    {previewList[currentImgIndex]?.name}
                </div>
                </div>
                {previewList.length > 1 && (
                <div className="navigation">
                    <div className="prev" onClick={onPrev}></div>
                    <div className="next" onClick={onNext}></div>
                </div>
                )}
            </div>
            </div>
        )}
        </>
    );
};

export default DocumentDetails;
